// La conversacion con el Brain en la que se estaba, recordada en el navegador.
//
// Es lo que hace que recargar no te saque de ella: el Brain sigue trabajando en
// el servidor, y al volver la pantalla abre la misma conversacion y retoma el
// «pensando». Es una comodidad de este navegador, no estado compartido: la
// conversacion y su encargo viven en el servidor.
//
// Envuelto en `try` porque en una ventana privada o con el almacenamiento
// bloqueado **leer lanza**, y quedarse sin Brain por no poder recordar un hilo
// seria peor que empezar uno nuevo.

const KEY = 'muveran.brain.hilo'

export function rememberedThread(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}

export function rememberThread(thread: string): void {
  try {
    localStorage.setItem(KEY, thread)
  } catch {
    // Sin recuerdo, al recargar se empieza una conversacion nueva. Nada se pierde:
    // la de antes sigue en la lista.
  }
}
